import React, {useState, useEffect} from "react";
import { Form, Button } from "antd";
import LanguageFields from "./LanguageFields";

const name = "language_attributes"

  const LanguageForm = ({form, languages, initValues=[], readonly=false}) => {
    const [id, setId] = useState(initValues?.length)
    const fields = form.getFieldValue(name) || [...Array(initValues?.length).keys()]

    const add = () => {
      const keys = form.getFieldValue(name);
      const nextKeys = keys.concat(id);
      setId(id+1)
      form.setFieldsValue({
        [name]: nextKeys,
      });
    }

    const remove = (k) => {
      const keys = form.getFieldValue(name);
      form.setFieldsValue({
        [name]: keys.filter(key => key !== k),
      });
    }

    form.getFieldDecorator(name , { initialValue: [...Array(initValues.length).keys()] })

    return(
        <>
            {fields.map((value, index) => (
                <div key={index}>
                    <LanguageFields
                        form={form}
                        id={value}
                        initialValues={initValues.length>index ? initValues[index] : null}
                        languages={languages}
                        remove={() => remove(value)}
                        readonly={readonly}
                    />
                </div>
            ))}
            <Form.Item>
                <Button className="custom-button-postulation" onClick={add} block disabled={readonly == true}>
                + Agregar nuevo idioma
                </Button>
            </Form.Item>

        </>
    )
}

export default LanguageForm
